import {h, Component} from 'preact';
import Register from 'components/register';
import linkstate from 'linkstate';
import firebase from 'utils/firebase';


class Login extends Component {
	validate = () => {
		const {email,password} = this.state;
		if(!email || !email.split('@')[1] || email.split('@')[1].indexOf('.') === -1 || !email.split('@')[1].split('.')[1] ) {
			this.setState({error: 'email'});
			return false;
		}

		if(!password || password.length < 6) {
			this.setState({error: 'password'});
			return false;
		}

		return true;
	}
	submit = (e) => {
		e.preventDefault();
		e.stopImmediatePropagation();
		this.setState({ loading: true, error: null });

		const {email, password} = this.state;

		if(this.validate()) {
			this.setState({loading: true});
			firebase.auth()
				.signInWithEmailAndPassword(email, password)
				.catch((error) => {
					// Handle Errors here.
					this.setState({loading: false, error });
					console.error(error);
				});
		} else {
			this.setState({ loading: false });
		}
	}
	reset = (e) => {
		e.preventDefault();
		e.stopImmediatePropagation();
		this.setState({ loading: true, error: null });

		const { email} = this.state;

		if(email) {
			this.setState({loading: true});
			firebase.auth()
				.sendPasswordResetEmail(email)
				.then(res => {
					this.setState({loading: false, success:true});
				})
				.catch((error) => {
					// Handle Errors here.
					this.setState({loading: false, error });
					console.error(error);
				});
		} else {
			this.setState({ loading: false });
		}
	}

	render(props,state) {
		return <div>
					<div class="modal-backdrop fade show" />
					<div class="modal fade show" id="contact-box-modal" tabindex="-1" role="dialog" aria-modal="true" style="display: block;">
						<div class="modal-dialog modal-dialog-centered" role="document">
							<div class="modal-content">
								<div class="modal-body">
									<button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={props.onClose}>
										<svg class="icon bg-dark" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M16.2426 6.34311L6.34309 16.2426C5.95257 16.6331 5.95257 17.2663 6.34309 17.6568C6.73362 18.0473 7.36678 18.0473 7.75731 17.6568L17.6568 7.75732C18.0473 7.36679 18.0473 6.73363 17.6568 6.34311C17.2663 5.95258 16.6331 5.95258 16.2426 6.34311Z" fill="#212529"></path>
											<path d="M17.6568 16.2426L7.75734 6.34309C7.36681 5.95257 6.73365 5.95257 6.34313 6.34309C5.9526 6.73362 5.9526 7.36678 6.34313 7.75731L16.2426 17.6568C16.6331 18.0473 17.2663 18.0473 17.6568 17.6568C18.0474 17.2663 18.0474 16.6331 17.6568 16.2426Z" fill="#212529"></path>
										</svg>
									</button>
									{!state.forgot ?
									<div class="p-4">

										 <div class="row text-left justify-content-between">
				 							<div class="col-auto">
				 								<h5> Kirjaudu sisään</h5>
				 							</div>
				 							<div class="col-auto">
				 								<p class="text-small text-600"><a href="#" onClick={e => {e.preventDefault();e.stopImmediatePropagation(); props.onRegister()}}>Luo tunnus</a></p>
				 							</div>
				 						</div>

										{state.error && typeof state.error !== 'string' ? <div class="alert alert-primary" role="alert">
											Kirjautuminen ei onnistu, tarkistathan tietosi. Jos ongelma jatkuu, ota yhteyttä asiakaspalveluun.
											 <br /><br />
											 Virheviesti: "<em>{state.error.message}</em>"
										 </div> : null}

				 						<form onSubmit={this.submit}>
											<div class="form-group">
												<input type="email" class="form-control" autocomplete="email" id="email" placeholder="" onInput={linkstate(this,'email')} value={state.email} required="" placeholder="Sähköpostiosoite"/>
												<div class="invalid-feedback" style={state.error === 'email' ? 'display:block;' : null}>
													Tarkista sähköpostiosoitteesi
												</div>
											</div>
											<div class="form-group">
												<input type="password" autocomplete="new-password" class="form-control" id="password" placeholder="" onInput={linkstate(this,'password')} value={state.password} required=""  placeholder="Salasana"/>
												<div class="invalid-feedback" style={state.error === 'password' ? 'display:block;' : null}>
													Salasana on pakollinen kenttä. Salasanan tulee olla vähintään 6 merkkiä.
												</div>
											</div>
				 							<div class="row justify-content-between  mb-3">
				 								<div class="col-auto"><a class="text-small" href="#" onClick={e => {e.preventDefault();e.stopImmediatePropagation(); this.setState({forgot:true, error: null})}}>Unohditko salasanasi?</a></div>
				 							</div>
				 							<div class="form-group">
												{state.loading ?
												<button class="btn btn-primary btn-block btn-loading btn-loading-animate" disabled>
													<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="injected-svg icon" data-src="assets/img/icons/theme/code/loading.svg">
														<title>Icon For Loading</title>
														<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															<g>
																<polygon points="0 0 24 0 24 24 0 24" opacity="0"></polygon>
															</g>
															<path d="M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,10.9603196 17.7360885,9.96126435 17.2402578,9.07513926 L18.9856052,8.09853149 C19.6473536,9.28117708 20,10.6161442 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z" fill="#000000" fill-rule="nonzero" transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, 12.000000)"></path>
														</g>
													</svg>
													<span>Ladataan</span>
												</button>
												:
												<button class="btn btn-primary btn-block" type="submit" onClick={this.submit}>Kirjaudu sisään</button>
												}
				 							</div>

										</form>
									</div>
									:
									state.success ?
									<div class="p-4">
										<div class="row text-left justify-content-between">
											<div class="col-auto">
												<h5>Salasanan alustamisohjeet on nyt lähetetty sähköpostiisi!</h5>
												<p>Muistathan katsoa myös roskapostikansiosi.</p>
												<button class="btn btn-primary btn-block mt-4" type="submit" onClick={e => {e.preventDefault();e.stopImmediatePropagation(); this.setState({forgot:false, error: null})}}>Takaisin kirjautumiseen</button>
											</div>
										</div>
									</div>
									:
									<div class="p-4">

										 <div class="row text-left justify-content-between">
				 							<div class="col-auto">
				 								<h5>Unohdin salasanani</h5>
				 							</div>
				 							<div class="col-auto">
				 								<p class="text-small text-600"><a href="#" onClick={e => {e.preventDefault();e.stopImmediatePropagation(); this.setState({forgot:false, error: null})}}>Takaisin kirjautumiseen</a></p>
				 							</div>
				 						</div>

										{state.error && typeof state.error !== 'string' ? <div class="alert alert-primary" role="alert">
											Salasanan nollaus ei onnistu, tarkistathan tietosi. Jos ongelma jatkuu, ota yhteyttä asiakaspalveluun.
											 <br /><br />
											 Virheviesti: "<em>{state.error.message}</em>"
										 </div> : null}

				 						<form onSubmit={this.reset}>
				 							<div class="form-group">
				 								<input class="form-control" type="email" required autocomplete="email" placeholder="Sähköpostiosoite" onInput={linkstate(this,'email')} value={state.email} />
				 							</div>

				 							<div class="form-group">
												{state.loading ?
												<button class="btn btn-primary btn-block btn-loading btn-loading-animate" disabled>
													<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="injected-svg icon" data-src="assets/img/icons/theme/code/loading.svg">
														<title>Icon For Loading</title>
														<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															<g>
																<polygon points="0 0 24 0 24 24 0 24" opacity="0"></polygon>
															</g>
															<path d="M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,10.9603196 17.7360885,9.96126435 17.2402578,9.07513926 L18.9856052,8.09853149 C19.6473536,9.28117708 20,10.6161442 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z" fill="#000000" fill-rule="nonzero" transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, 12.000000)"></path>
														</g>
													</svg>
													<span>Ladataan</span>
												</button>
												:
												<button class="btn btn-primary btn-block" type="submit" onClick={this.reset}>Lähetä sähköposti</button>
												}
				 							</div>

										</form>
									</div>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
	}
}

export default Login



// WEBPACK FOOTER //
// ./components/login/index.js